/* Presentation only: native Impulse handles cart requests and checkout. */
(() => {
  if (!customElements.get('tbc-cart-faq')) {
    customElements.define('tbc-cart-faq', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        const panels = [...this.querySelectorAll('[data-faq-panel]')];
        const buttons = [...this.querySelectorAll('[data-faq-index]')];
        const show = index => {
          panels.forEach((panel, i) => { panel.hidden = i !== index; });
          buttons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
        };
        buttons.forEach(button => button.addEventListener('click', () => show(Number(button.dataset.faqIndex))));
        show(0);
        this.querySelector('.tbc-cart-faq__navigation').hidden = false;
      }
    });
  }
})();
